import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { selectPumpDetails } from '../selectors';

const normalizePumpId = (pumpID) => {
  const normalized = String(pumpID ?? '').trim().toLowerCase();
  return ['pm', 'pressure maintenance', 'sustain'].includes(normalized) ? 'pm' : normalized;
};

const initialState = {
  activePumps: {},
};

export const updateActivePumps = createAsyncThunk(
  'activePumps/updateActivePumps',
  async (jobId, { getState }) => {
    const state = getState();
    const pumpDetails = selectPumpDetails(state);

    const jobPumpDetails = pumpDetails.filter(pump => pump.ProjectID === jobId);

    const activePumps = {
      HasSustain: jobPumpDetails.some(pump => normalizePumpId(pump.PumpID) === 'pm'),
      HasMain: jobPumpDetails.some(pump => normalizePumpId(pump.PumpID) === 'main'),
      HasWaterFeature: jobPumpDetails.some(pump => normalizePumpId(pump.PumpID) === 'water feature'),
      HasTransfer: jobPumpDetails.some(pump => normalizePumpId(pump.PumpID) === 'transfer'),
      HasRecirc: jobPumpDetails.some(pump => normalizePumpId(pump.PumpID) === 'recirculation'),
      HasTrash: jobPumpDetails.some(pump => normalizePumpId(pump.PumpID) === 'trash'),
    };

    return { jobId, activePumps };
  }
);

const activePumpsSlice = createSlice({
  name: 'activePumps',
  initialState,
  reducers: {
    setActivePumps: (state, action) => {
      state.activePumps = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateActivePumps.fulfilled, (state, action) => {
      const { jobId, activePumps } = action.payload;
      state.activePumps[jobId] = activePumps;
    });
  },
});

export const { setActivePumps } = activePumpsSlice.actions;

export const selectActivePumps = (state, jobId) => state.activePumps.activePumps[jobId];

export default activePumpsSlice.reducer;
